import { useCallback, useEffect } from 'react';

import { useNotification as useNotificationSmart } from '@s_mart/hooks';

import useApp from 'store/app/app';

export const useNotification = () => {
  const { notification, setNotification } = useApp();
  const notificationSmart = useNotificationSmart();

  const _handleClose = useCallback(() => {
    setNotification(null);
  }, [setNotification]);

  useEffect(() => {
    if (notification) {
      notificationSmart.setNotification({
        ...notification,
        title: notification.title ?? '',
      });

      _handleClose();
    }
  }, [notification, _handleClose, notificationSmart]);
};
